import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';

import Utils from 'src/app/utils';
import * as _ from 'lodash-es';
declare var require: any;
declare var bootstrap: any;

import timezones from 'timezones-list';

declare var require: any;

@Component({
  selector: 'app-group-edit',
  templateUrl: './group-edit.component.html',
  styleUrls: ['./group-edit.component.scss']
})
export class GroupEditComponent implements OnInit {

  group: any;
  workers: any;
  id?: number;
  check_in_times: { value: number; name: string }[] = [];
  alert_times = Utils.getAlertTimes();
  alert_repeat = Utils.getAlertReminder();
  day_hours = Utils.getDayHours();
  auto_end_shift: any;
  alert_loops:any;

  u = Utils;
  _ = _;

  callRepeats:any;
  smsRepeats:any;
  numOfRepeats:any;
  tooManyRepeats = false;

  call_reminders = true;
  sms_reminders = true;

  formGroup = new FormGroup({
    name: new FormControl('',[Validators.required]),
    check_in_freq: new FormControl('',[]),
    monitors: new FormControl([],[]),
    alert_loop: new FormControl('',[]),
    timezone: new FormControl('',[]),
    sms_alert: new FormControl('',[]),
    call_alert: new FormControl('',[]),
    email_alert: new FormControl('',[]),
    call_alert_repeat: new FormControl('',[]),
    sms_alert_repeat: new FormControl('',[]),
    auto_end_shift: new FormControl('',[]),
    outhrs_monitors: new FormControl('',[]),
    outhrs_alertloop: new FormControl('',[]),
    sync: new FormControl(false,[]),
  })
  color = '';
  submitted = false;


  workerFormGroup = new FormGroup({
    ids: new FormControl([],[Validators.required])
  })

  submittedWF = false;

  get f(): { [key: string]: AbstractControl } {
    return this.formGroup.controls;
  }

  countryListArray  = Utils.getCountries();
  timezoneListArray = timezones;

  send_loading = false;
  send_monitor_loading = false;

  view_comms = false;
  view_escalation = false;
  view_outhrs = false;

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, public transloco: TranslocoService) {


    console.log(this.formGroup);

   }

  ngOnInit(): void {

    this.id = +this.route.snapshot.params['id'];



    this.getGroup();
    
  }

  ngAfterViewInit()	: void {
    Utils.setupPopover();
  }

  setupCheckInTimes(){
    this.check_in_times = Utils.getCheckinTimes(this.okService.settings?.id);

    let check_in_time = _.find(this.check_in_times,{'value':this.group.check_in_freq}); 
  
    // If ARC then remove 30mins
    if(this.okService.settings.arc_on){
        this.check_in_times.splice(1, 1); // 2nd parameter means remove one item only
    }
      
    if(!check_in_time){
      this.check_in_times[0] = {"value":this.group.check_in_freq,"name":this.group.check_in_freq+" mins"}
      this.check_in_times.unshift({"value":6000,"name":"No Timer"});
    }
  

  }


  getGroup(){

    this.okService.get("groups/"+this.id,{expand:'workers,sync'})
    .subscribe((data) => {

      this.group = data.body;
      this.alert_loops = [{id:0,name:"No Alert Loop"}].concat(this.okService.alert_loops);

      //console.log(this.group);

      this.setForm();
      this.setupCheckInTimes();
    })

  }

  setForm(){

    this.formGroup.setValue({
      name: this.group.name,
      check_in_freq: this.group.check_in_freq,
      monitors: this.group.monitors,
      alert_loop: this.group.alert_loop,
      //country: this.group.country,
      timezone: this.group.timezone,
      sms_alert: this.group.sms_alert,
      sms_alert_repeat: this.group.sms_alert_repeat,
      call_alert: this.group.call_alert,
      call_alert_repeat: this.group.call_alert_repeat,
      auto_end_shift: this.group.auto_end_shift,
      email_alert: this.group.email_alert,
      outhrs_monitors: this.group.outhrs_monitors,
      outhrs_alertloop: this.group.outhrs_alertloop,
      sync: this.formGroup.value.sync ? this.formGroup.value.sync : false,
    });
    this.color = this.group.color == null ? '' : this.group.color;
    this.workerFormGroup.setValue({
      ids: []
    });

    if(this.okService.settings.arc_on){
      this.formGroup.controls['call_alert'].disable();
      this.formGroup.controls['sms_alert'].disable();
      this.formGroup.controls['sms_alert_repeat'].disable();
      this.formGroup.controls['call_alert_repeat'].disable();
      this.formGroup.controls['email_alert'].disable();
    }

    if(!this.okService.hasMonitorAccess('groups','update')){

      this.formGroup.controls['name'].disable();
      this.formGroup.controls['check_in_freq'].disable();
      this.formGroup.controls['monitors'].disable();
      this.formGroup.controls['alert_loop'].disable();
      this.formGroup.controls['timezone'].disable();
      this.formGroup.controls['sms_alert'].disable();
      this.formGroup.controls['sms_alert_repeat'].disable();
      this.formGroup.controls['call_alert'].disable();
      this.formGroup.controls['call_alert_repeat'].disable();
      this.formGroup.controls['auto_end_shift'].disable();
      this.formGroup.controls['email_alert'].disable();
      this.formGroup.controls['outhrs_monitors'].disable();
      this.formGroup.controls['outhrs_alertloop'].disable();
      this.formGroup.controls['sync'].disable();
      
    }

    //this.totalRepeats();
    this.hideCallReminders();
    this.hideSMSReminders();
    this.setupMonitorLimit();

  }

  submitForm(){

    if(this.submitted){
      Object.keys(this.formGroup.controls).forEach(key => {
        this.formGroup.get(key)?.setErrors({ invalid: null });
        this.formGroup.get(key)?.updateValueAndValidity();
      });
    }

    this.submitted = true;
    if (this.formGroup.valid) {
      let values:any = this.formGroup.value
      values.color = this.color;
      //console.log('submitForm values', values);

      if(values.sync){
        if(confirm(this.transloco.translate("Are you sure you want to update all workers with these values?"))) {
          this.processForm(values);
        }
      }else{
        this.processForm(values);
      }


    }

    return false;

  }

  processForm(values:any){
      this.okService.put("groups/"+this.id,values)
      .subscribe({
        next: (data) => {
          this.getGroup();

          //console.log('edited group',this.group);
          this.okService.setAlert(this.transloco.translate("The group has been updated"), "success");

        },
        error: (e) => {

          if(Array.isArray(e)){
            let self = this;
            // Use of _.forEach() method
            _.forEach(e, function(error:any) {
              //console.log(error);
              self.formGroup.get(error.field)?.setErrors({ invalid: error.message });
            });
          }else{
            this.okService.setAlert(e,"warning")
          }


        },
        complete: () => {
          //console.info('complete');
        }
    });
  }

  doDelete(){
    if(confirm(this.transloco.translate("Are you sure you want to delete ")+this.group.name)) {

      this.okService.delete("groups/"+this.group.id)
      .subscribe((data) => {

        this.okService.setAlert(this.transloco.translate("The group has been deleted"), "success");
        this.router.navigateByUrl('/mgmt/groups/groups');

      });
    }
  }

  doAddWorker(){

    this.submittedWF = true;
    if(this.workerFormGroup.valid){

      let values = this.workerFormGroup.value;

      //console.log(values);

      this.okService.put("groups/addworkers/"+this.group.id,values)
      .subscribe((data) => {

        this.getGroup();

        this.okService.setAlert(this.transloco.translate("The worker has been added to the group."), "success");
      })
    }

    return false;
  }

  doRemoveWorker(worker:any){
    if(confirm(this.transloco.translate("Are you sure you want to remove ")+worker.name+this.transloco.translate(" from this group"))) {

        this.okService.put("groups/removeworkers/"+this.group.id,{id:worker.id})
        .subscribe((data) => {

          this.getGroup();

          this.okService.setAlert(this.transloco.translate("The worker has been removed from the group."), "success");
        })

    }

  }

  syncWorker(worker:any){


    this.okService.put("groups/syncworkers/"+this.group.id,{id:worker.id})
    .subscribe((data) => {

      this.getGroup();

      this.okService.setAlert(this.transloco.translate("The worker has been synchronised"), "success");
    })


  }
  syncWorkers(){


    this.okService.put("groups/syncworkers/"+this.group.id,{})
    .subscribe((data) => {
      this.getGroup();
      this.okService.setAlert(this.transloco.translate("The workers have been synchronised"), "success");
    })

  }

  onColorChange(event:any){

    this.color = event;

  }

  sendLinks(){

    this.send_loading = true;

    this.okService.put("groups/sendlinks/"+this.group.id,{})
    .subscribe((data) => {

      this.send_loading = false;

      this.okService.setAlert(this.transloco.translate("The worker links have been sent out"), "success");

    })
  }

  sendMonitorEmails(){

    this.send_monitor_loading = true;

    this.okService.put("groups/sendmonitoremails/"+this.group.id,{})
    .subscribe((data) => {

      this.send_monitor_loading = false;

      this.okService.setAlert(this.transloco.translate("The monitor welcome emails have been sent"),"success");

    });

  }

  totalRepeats(){
    if(!this.okService.isFromAdmin()){
      
      if(this.formGroup.value.call_alert != '0' && this.formGroup.value.sms_alert != '0'){

        this.callRepeats = this.formGroup.value.call_alert_repeat! + 1;
        this.smsRepeats = this.formGroup.value.sms_alert_repeat! + 1;
        this.numOfRepeats = this.callRepeats + this.smsRepeats;

        console.log('total repeats',this.numOfRepeats);

        if(this.numOfRepeats > 4){
          this.tooManyRepeats = true;
        }else{
          this.tooManyRepeats = false;
        }

      }
    }

  }

  // Hide the call reminders if the call alert is none
  hideCallReminders(){
    if(this.formGroup.get('call_alert')?.value){
      this.call_reminders = true;
    }else{
      this.call_reminders = false;
    }
  }

  // Hide the sms reminders if the sms alert is none
  hideSMSReminders(){
    if(this.formGroup.get('sms_alert')?.value){
      this.sms_reminders = true;
    }else{
      this.sms_reminders = false;
    }
  }

  // If monitors number is equal to or less than 4 set a validator limit of 4
  // If monitors is 4 or greater then put an alert mentioning that 4 is the preferred limit
  setupMonitorLimit(){

    // Don't set the limit if the user is from the admin area
    if(this.okService.isFromAdmin()){
      return;
    }

    let numOfMonitors = this.group.monitors.length;

    let maxMonitors = 5;
    if(this.okService.settings.id < 4000){
      maxMonitors = 10;
    }

    if(numOfMonitors < maxMonitors){
      // console.log('add Validator');
      this.formGroup.get('monitors')!.addValidators(Validators.maxLength(maxMonitors));
    }

    let numOfOOHMonitors = this.group.outhrs_monitors.length;

    if(numOfOOHMonitors <= maxMonitors){
      // console.log('add Validator');
      this.formGroup.get('outhrs_monitors')!.addValidators(Validators.maxLength(maxMonitors));
    }

  }

}
